import React from 'react'
import { Tag } from 'front-end/src/components'
import IconX from 'front-end/src/components/common/icon/IconX'

type ChipsInputListProps = {
  chipsList: string[]
  invalidList?: string[]
  handleCloseClick: (
    ev: React.MouseEvent<HTMLSpanElement>,
    textValue?: string
  ) => void
}

const ChipsInputList = ({
  chipsList,
  handleCloseClick,
  invalidList = []
}: ChipsInputListProps) => {
  return (
    <>
      {chipsList.length > 0 &&
        chipsList.map((chip) => (
          <Tag
            m="2px 4px 2px 0"
            key={chip}
            onClickClose={handleCloseClick}
            textValue={chip}
            color={invalidList?.includes(chip) ? 'chipError' : 'chip'}
            closeIcon={IconX}
            zIndex={1}
          >
            {chip}
          </Tag>
        ))}
    </>
  )
}

export default React.memo(ChipsInputList)
